import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConstants } from '@wz-constants';
import { QuotationModels } from '@wz-models';

@Component({
  selector: 'wz-etre-rappele-dialog',
  templateUrl: './etre-rappele-dialog.component.html',
  styleUrls: ['./etre-rappele-dialog.component.scss'],
  standalone: false,
})
export class EtreRappeleDialogComponent implements OnInit, AfterViewInit {
  quotationParamOrigin = null;
  number_phone: any = null;
  constructor(
    public dialogRef: MatDialogRef<EtreRappeleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ngAfterViewInit(): void {
    this.setNumberSite();
  }

  ngOnInit() {
    this.setNumberSite();
  }

  setNumberSite() {
    let paramOrigin = localStorage.getItem('paramOrigin');
    this.quotationParamOrigin = null;
    if (!paramOrigin) {
      this.number_phone = AppConstants.SiteNumber.NUMBER;
    } else {
      this.number_phone = AppConstants.SiteNumber.NUMBER_FRNACHISE;
    }
  }

  valider: boolean = false;
  validerRappel() {
    this.valider = true;
  }
  closeModals(): void {
    this.dialogRef.close();
    this.valider = false;
  }
  ate(a: string) {
    a = a.replace(',', '.');
    var r: number = +a;
    return r;
  }

  //regex phone number france
  regexPhoneNumber(str: string) {
    const regexPhoneNumber = /^((\+)33|0)[1-9](\d{2}){4}$/;

    if (str.match(regexPhoneNumber)) {
      return true;
    } else {
      return false;
    }
  }
  telephoneInexistant(inputTelephone: string): boolean {
    //Numeros inexistants
    if (
      inputTelephone == '0102030405' ||
      inputTelephone == '0101010101' ||
      inputTelephone == '0202020202' ||
      inputTelephone == '0601020304'
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export interface DialogData {
  telephone: string;
  produit: QuotationModels.ReponseAfiExport;
  tarif: QuotationModels.Tarif;
}
